<template>
  <div>
    <Title
      :title-text="$t('register_title_text')"
      :text="`${$t('register_account_title')}?`"
      :link-text="$t('register_loginTitle_text')"
      route="login"
      data-qa="por-register--title" />
    <RegisterForm data-qa="Register-form"/>
  </div>
</template>

<script>
import { track } from '@/services/tracking'

import Title from '@/components/title'
import RegisterForm from '@/components/forms/register'

export default {
  name: 'Login',
  components: {
    Title,
    RegisterForm
  },
  mounted () {
    track({ name: 'page view', params: { module: 'register' } })
  }
}
</script>
